import styled from "styled-components";
var Label =
/*#__PURE__*/
styled.label.withConfig({
  displayName: "Label"
})(["display:inline-block;font-weight:bold;color:", ";", ""], function (_ref) {
  var theme = _ref.theme,
      isError = _ref.isError;
  return isError ? "#b30021" : theme.paragraph.color;
}, function (_ref2) {
  var $required = _ref2.$required;
  return $required ? "\n    ::after {\n      content: \"*\";\n    }\n  " : "";
});
export default Label;